import { Injectable, signal } from '@angular/core';

/**
 * Manages version check alerts to prevent duplicates and stacking.
 * Ensures only one version update alert shows at a time across all sources
 * (login, background sync, etc).
 */
@Injectable({ providedIn: 'root' })
export class VersionCheckAlertService {
  /** Global flag: prevents multiple alerts from showing simultaneously. */
  private alertOpen = signal(false);

  /** Check if an alert is currently open. */
  isAlertOpen(): boolean {
    return this.alertOpen();
  }

  /** Mark alert as open. */
  openAlert(): void {
    this.alertOpen.set(true);
  }

  /** Mark alert as closed (user dismissed or selected option). */
  closeAlert(): void {
    this.alertOpen.set(false);
  }
}
